<template>
    <!--v-flex xs12 sm8 offset-sm2-->
    <v-form v-model="valid" class="fullwidth">
        <v-container grid-list-md text-xs-center pa-0>
            <v-layout wrap>
                Nuevo Cliente
                <v-flex xs12>
                    <v-text-field v-model="newCustData.name" label="Razón social" type="text" required></v-text-field>
                </v-flex> 
                <v-flex xs12>
                    <v-text-field v-model="newCustData.searchName" label="Alias" type="text" required></v-text-field>
                </v-flex> 
                <v-flex xs12>
                    <v-text-field v-model="newCustData.cif" label="CIF (opcional)" type="text"></v-text-field>
                </v-flex> 
            </v-layout>
        </v-container>
    </v-form>
</template>
<script>
export default {
    name: 'formCliente',     
    data () {
        return {                        
           name: '',
           alias: '',
           cif: '',
           valid: false
        }
    },
    methods: {
        
    },
    components:{
        
    },
    computed:{
        newCustData:{
            get(){
                return this.$store.state.newCustData;
            },
            set(value){
                this.$store.commit('setNewCustData',value);
            } 
        }
    },
    mounted(){
               
    },
    watch:{
        
    }
}
</script>
<style scoped>

</style>